import type { TFunction } from 'i18next';

/** GraphQL `AddressType` enum value as string. */
export function translateAddressType(t: TFunction, type: string): string {
  const key = `orgAddresses.addressType.${type}`;
  const label = t(key);
  return label === key ? type : label;
}
